import modular from 'stereomodularjs';
import * as modules from './modules';
import globals from './globals';
import { html } from './utils/environment';
import './utils/events';

const app = new modular({
    modules: modules
});

window.onload = (event) => {
    const $style = document.getElementById('main-css');
    classAdd(document.querySelector('body'), 't-' + document.querySelector('.js-scroll').getAttribute('data-namespace'))

    if ($style) {
        if ($style.isLoaded){
            init();
        } else {
            $style.addEventListener('load', (event) => {
                init();
            });
        }
    } else {
        console.warn('The "main-css" stylesheet not found');
    }

    let isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    window.isMobile = isMobile;

    if(window.isMobile) {
        html.classList.add('is-mobile');
    }
};

function init() {
    globals();

    app.init(app);

    setTimeout(() => {
        html.classList.add('is-first-loaded');
        let preventChilds = document.querySelectorAll('.js-prevent-childs a');
        preventChilds.forEach(el => {
            el.classList.add('js-prevent');
        });
    }, 50);

    setTimeout(() => {
        html.classList.add('is-loaded');
        html.classList.add('dom-is-loaded');
        html.classList.remove('is-loading');
        // call window resize event
        window.dispatchEvent(new Event('resize'));
    }, 1000);
}
